<div mat-dialog-title>
  <h2>{{ 'authorization-history.title' | translate }}</h2>
</div>
<mat-progress-bar [mode]="inProgress ? 'indeterminate' : 'determinate'"></mat-progress-bar>

<mat-dialog-content>
  @if (hasData$ | async) {
    <div *ngIf="tz" class="tz">
      {{ 'common.history-tz-text' | translate }} <b>{{ tz }}</b>.
    </div>
    <div *ngFor="let day of histories$ | async; let i = index" class="day-block">
      <div>
        <div class="day">
          {{ day.date.calendar(null, calendarFormats) }}
        </div>
        <div class="date">
          {{ day.date | momentDate:tz }}
        </div>
      </div>
      <div class="records">
        <div *ngFor="let record of day.records" class="record">
          <div class="time">
            {{ record.createdAt | momentTime:tz:'LT' }}
          </div>
          <div class="data">
            <div>
              {{ getEventTypeText(record) }}
              <a
                *ngIf="record.authorization?.identifier"
                (click)="onOpenAuthorization(record.authorization)"
                class="text-link"
              >
                {{ record.authorization?.identifier }}
              </a>
              <b *ngIf="record.clinician" [matTooltip]="record.clinician.email">{{ getByText(record) }}</b>
            </div>

            <div *ngIf="shouldShowLogType(record)" class="log-type-info">
              <b>{{ 'authorization-history.log-type' | translate }}:</b> {{ getLogTypeText(record) }}
            </div>

            <div *ngIf="record.message" class="message-info">
              <b>{{ 'authorization-history.message' | translate }}:</b> {{ record.message }}
            </div>

            <div *ngFor="let change of getChanges(record)">
              <b>{{ change.key | mmxTitlecase }}</b><span [innerHTML]="change.value"></span>
            </div>

            <div *ngIf="shouldShowPortal(record)" class="portal-info">
              <b>{{ 'authorization-history.portal' | translate }}:</b> {{ getSourceApi(record) | authorizationRuleAPIName | translate }}
            </div>

            <div *ngIf="shouldShowTrigger(record)" class="trigger-info">
              <b>{{ 'authorization-history.trigger' | translate }}:</b> {{ getTriggerText(record) }}
            </div>

            <div *ngIf="isEmrImport(record)" class="emr-import">
              <b>{{ 'authorization-history.emr-import' | translate }}</b>
            </div>

            <div *ngIf="record.eventType === 'F' && !actionHistoriesMap[record.id]" class="text-center pt-4 pb-4">
              <button mat-stroked-button color="primary" type="button" (click)="onLoadEventAction(record)">
                {{ 'authorization-history.show-errors' | translate }}
              </button>
            </div>

            <div *ngIf="actionHistoriesMap[record.id]?.length">
              <hr class="mt-3" />
              <b>{{ 'authorization-history.error-responses' | translate }}:</b>
              <ul class="pl-4 mt-0">
                <ng-container *ngFor="let action of actionHistoriesMap[record.id]">
                  @if (action.data.errors) {
                    @for (error of action.data.errors; track $index) {
                      <li *ngIf="error.errorMessage" class="error">
                        {{ error.errorMessage }}
                      </li>
                    }
                  }
                </ng-container>
              </ul>
            </div>
            <div class="text-right">
              <ng-container [ngSwitch]="getActorKind(record)">
                <i *ngSwitchCase="'clinician'" [matTooltip]="getActorEmail(record)">{{ getActorName(record) }}</i>
                <i *ngSwitchCase="'patient'">{{ 'authorization-history.actor.patient' | translate }}</i>
                <i *ngSwitchCase="'emr'">{{ 'authorization-history.actor.emr' | translate }}</i>
                <i *ngSwitchDefault>{{ 'common.system' | translate }}</i>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
  @else if (historiesError$ | async) {
    <div class="text-center mt-5 mb-4 text-danger">
      {{ 'authorization-history.load-error' | translate }}
    </div>
  }
  @else if (inProgress === false && !hasMore) {
    <div class="text-center mt-5 mb-4">
      {{ 'authorization-history.no-history' | translate }}
    </div>
  }
  @else if (inProgress) {
    <div class="text-center mt-5 mb-4">
      {{ 'common.loading' | translate }}...
    </div>
  }

  @if (loadMoreFailed) {
    <div class="text-center mt-3 text-danger">
      {{ 'authorization-history.load-error' | translate }}
    </div>
  }

  @if (hasMore) {
    <div class="text-center mt-3 mb-2">
      <button mat-stroked-button [disabled]="inProgress" (click)="loadMore()">
        {{ (inProgress ? 'common.loading' : 'authorization-history.load-more') | translate }}
      </button>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close>Close</button>
</mat-dialog-actions>
